import NumberedSteps from './NumberedSteps.vue'

export default NumberedSteps
